import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import { ProgramComponent } from '@lean-body/components/molecules';
export const Programs = ({ classObject, programs, addFavoriteProgram, unFavoriteProgram, onClickProgram, isSM, }) => {
    if (!programs) {
        return null;
    }
    const styles = StyleSheet.create({
        container: {
            display: 'flex',
            gap: '12px 0',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            [MediaBreakPointUp.MD]: {
                gap: '20px 0',
            },
        },
    });
    return (React.createElement("div", { className: css(styles.container, classObject) }, programs.map((program) => (React.createElement(ProgramComponent, { key: program.id, program: program, onClick: onClickProgram, addFavoriteProgram: addFavoriteProgram, unFavoriteProgram: unFavoriteProgram, isVertical: !isSM })))));
};
